export default __webpack_public_path__ + "static/media/partner-wvs.b7f8ef6c.png";